<template>
  <div @click="emit" v-if="activeScan" class="scan">
    <div class="content">
      <img class="img" src="./scan.png" alt="">
      <div class="text-content">
        <p class="title">打开微信用力扫我</p>
        <p>扫码是请注意手机与屏幕的距离，未成年用户请在家长陪同下操作</p>
      </div>
    </div>

  </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: {
            activeScan:{
                type: Boolean,
                default: false
            }
        },
        computed:{
        },
        methods: {
            emit(){
                this.$emit("scanClick");
            }
        }
    }
</script>
<style scoped>
  .scan{
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 15;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.7);
    text-align: center;
  }
  .content{
    width: 250px;
    height: 250px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-80%);
    color: #fff;
  }
  .title{
    font-size: 18px;
    margin-bottom: 20px;
  }
  .text-content{
    margin-top: 30px;
    font-size: 12px;
    width: 350px;
    margin-left: -34px;
    font-weight: 100;
  }
</style>



// WEBPACK FOOTER //
// iScan.vue?0ccfbf1e